import {
  Box,
  Button,
  Spinner,
  Table,
  TableCaption,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MdAlarm } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { AllFormFunc } from "../Redux/Form/AllForm";
import { useNavigate } from "react-router-dom";
import { ViewFormFunc } from "../Redux/Form/ViewForm";
import { ViewMyFormFunc } from "../Redux/Form/ViewMyForm";
import { Assign } from "../Pages/Assign";
import CountdownTimer from "./CountdownTimer";
export const AllForms = () => {
  const allForms = useSelector((state) => state.All.data);
  const userId = useSelector((state) => state.user.userData.userId);
  const role = useSelector(
    (state) => state?.user?.userData?.userInfo?.userDetailsDto?.role
  );
  const viewMyForms = useSelector((state) => state.ViewMyForm.data);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const orgId = useSelector((state) => state.user.orgId);
  const Aloading = useSelector((state) => state.All.loading);
  const Uloading=useSelector((state)=>state.ViewMyForm.loading)
  console.log(Uloading,"uloading")
  
  // const [timeRemaining, setTimeRemaining] = useState(Date.now());

  const [currentTime,setCurrentTime]=useState(Date.now())

  useEffect(() => {
    
    const intervalId = setInterval(() => {
     setCurrentTime(Date.now())
    }, 1000);

    return () => clearInterval(intervalId);

    
  }, []);

  

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    if (role === "ADMIN") {
      dispatch(AllFormFunc(userId));
    } else {
      dispatch(ViewMyFormFunc(userId));
    }
  }, [userId]);
  console.log(allForms, "ALL form hai re");

  const handleViewForm = (id) => {
    dispatch(ViewFormFunc(id, userId));
    navigate(`/${id}/viewform?orgId=${orgId}`);
  };

  const handleFillForm = (id) => {
    navigate(`/${id}/fillform?orgId=${orgId}`);
  };

  const handleViewResponses = (id) => {
    navigate(`/${id}/responses?orgId=${orgId}`);
  };

  const handleAnalytics=(id)=>{
    navigate(`/${id}/analytics?orgId=${orgId}`);
  }
 


  return (
    <Box>
      {(role==="ADMIN"?Aloading:Uloading) === true ? (
        <Box display={"flex"} justifyContent={"center"} >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Box>
      ) : (
        <Box mt="2" overflowX="auto">
          <Table w="95%" m="auto" bgColor={"white"} >
            <Thead>
              {role === "ADMIN" ? (
                <Tr>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Form Name</Th>
                  {/* <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Created At</Th> */}
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>View</Th>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Assign</Th>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>View Responses</Th>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>View Analytics</Th>
                </Tr>
              ) : (
                <Tr>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Form Name</Th>
                  {/* <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Status</Th> */}
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Assign At</Th>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>View/Fill</Th>
                  <Th bgColor={"lavender"} color={"black"} border="1px solid black" py={4} textAlign={"center"}>Timer</Th>
                </Tr>
              )}
            </Thead>
            <Tbody>
              {(role === "ADMIN" ? allForms : viewMyForms)?.map((el, i) => {

                let timeRemaining=el.deadLine-currentTime

                // console.log(timeRemaining,"timeReminig")

                const countDown = `${Math.floor(timeRemaining / (1000 * 60 * 60))}H ${Math.floor((timeRemaining / (1000 * 60)) % 60)}M ${Math.floor((timeRemaining / 1000) % 60)}S`;
                // let dateString=""
                // if(role==="ADMIN"){
                 
                //  dateString= el.createdAt
                // }
                // else{
                //   const date = new Date(el.assignAt);
                //  dateString = date.toISOString().replace('T', ' ').substr(0, 19);
                // }

                

          //  if(timeRemaining<0){
          //   let intervalId
          //   if(intervalId){
          //       clearInterval(intervalId);
          //   }
          //    intervalId = setInterval(() => {

          //     timeRemaining=el.deadLine-currentTime
          //     // setTimeRemaining(deadline - Date.now());
          //     if (timeRemaining === 0) {
                
          //       clearInterval(intervalId);
          //     }
          //   }, 1000);
          //  }

                return (
                  <Tr key={i}>
                    <Td border="1px solid black" py={2} textAlign={"center"} fontWeight={"medium"} fontSize={"md"}>
                      {el.formTitle}
                    </Td>
                    {role === "USER" && (
                      <Td border="1px solid black" py={2} textAlign={"center"} color={el.status == "UNFILLED" ? "red" : "green"}>
                        {el.status}
                      </Td>
                    )}
                    {/* <Td border="1px solid black" py={2} textAlign={"center"} fontWeight={"medium"}>{dateString}</Td> */}

                    {role === "USER" && el.status == "UNFILLED" ? (
                     <>
                      {el.deadLine>currentTime?( <Td border="1px solid black" py={2} textAlign={"center"}>
                        <Button
                         
                          colorScheme="teal"
                          variant="outline"
                          onClick={() => handleFillForm(el.formId)}
                        >
                          Fill Form
                        </Button>
                      </Td>):(<Td border="1px solid black" py={2} textAlign={"center"}>
                      <Button
                        
                        colorScheme='green'
                        variant="solid"
                        onClick={() => handleViewForm(el.formId)}
                        isDisabled={true}
                      >
                        View Form
                      </Button>
                    </Td>)}
                     </>
                    ) : null}

                    {role === "USER" && el.status == "FILLED" ? (
                      <Td border="1px solid black" py={2} textAlign={"center"}>
                        <Button
                          
                          colorScheme='green'
                          variant="solid"
                          onClick={() => handleViewForm(el.formId)}
                        >
                          View Form
                        </Button>
                      </Td>
                    ) : null}

                    {role === "ADMIN" ? (
                      <Td border="1px solid black" py={2} textAlign={"center"}>
                        <Button
                          
                          colorScheme='green'
                          variant="solid"
                          onClick={() => handleViewForm(el.formId)}
                        >
                          View Form
                        </Button>
                      </Td>
                    ) : null}

                    {role === "ADMIN" ? (
                      <Td border="1px solid black" py={2} textAlign={"center"}>
                        <Button
                         
                          colorScheme="blue"
                          variant="solid"
                          onClick={() => onOpen()}
                        >
                          Assign
                        </Button>
                        {
                          <Assign
                            FormId={el.formId}
                            isOpen={isOpen}
                            onClose={onClose}
                          />
                        }
                      </Td>
                    ) : null}
                    <Td border="1px solid black" py={2} textAlign={"center"}>
                      {role === "USER" && el.status == "UNFILLED" ? (
                        <Box display={"flex"} alignItems="center" gap="2">
                          <CountdownTimer  Id={el.formId} countDown={countDown} show={el.deadLine>currentTime}  deadline={el.deadLine} />
                          
                          <MdAlarm size={"20"} />
                        </Box>
                      ) : null}

                      {role === "USER" && el.status == "FILLED" ? (
                        <Text color="green">Submitted Successfully !</Text>
                      ) : null}
                      {role === "ADMIN" && (
                        <Button
                          colorScheme="facebook"
                          variant={"solid"}
                          onClick={() => handleViewResponses(el.formId)}
                        >
                          View Responses
                        </Button>
                      )}
                    </Td>
                    {role === "ADMIN" && (
                      <Td border="1px solid black" py={2} textAlign={"center"}>
                        <Button colorScheme='linkedin' varient="solid" onClick={()=>handleAnalytics(el.formId)}>
                          View Analytics
                        </Button>
                      </Td>
                    )}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
};
